import { useEffect, useRef } from "react";
import JsBarcode from "jsbarcode";
import { QRCodeSVG } from "qrcode.react";
import { base } from "@/lib/wh";

export function ItemCodes({ item }) {
  const bar = useRef(null);
  useEffect(() => {
    if (bar.current) JsBarcode(bar.current, item.code, { format: "CODE128", height: 50, fontSize: 14, margin: 8 });
  }, [item.code]);
  return (
    <div className="rounded-2xl bg-white border border-[var(--border)] p-5 grid sm:grid-cols-[auto_1fr] gap-5 items-center" data-testid="wh-item-codes">
      <QRCodeSVG value={`${base()}/magazzino/a/${item.rand_code}`} size={132} data-testid="wh-item-qr" />
      <div className="space-y-2 min-w-0">
        <p className="text-sm">Numero articolo <b className="font-mono" data-testid="wh-item-code">{item.code}</b></p>
        <p className="text-sm">Codice univoco <b className="font-mono" data-testid="wh-item-rand">{item.rand_code}</b></p>
        <svg ref={bar} className="max-w-full" data-testid="wh-item-barcode" />
        <p className="text-xs text-[var(--muted)]">Il QR apre questa scheda solo dopo l'accesso. I codici non sono modificabili.</p>
      </div>
    </div>
  );
}
